import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MobileThemeService {
  private unsubscribeAll: Subject<any> = new Subject();

  private isBrowser: boolean;
  private darkMode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  get darkMode$(): Observable<boolean> {
    return this.darkMode.asObservable();
  }
  set darkMode$(value: any) {
    this.darkMode.next(value);
  }

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.initializeTheme();
    }
  }

  initializeTheme(): void {
    let isDark: boolean;
    try {
      const savedTheme = localStorage.getItem('elvktheme');
      if (savedTheme) {
        isDark = savedTheme === 'dark';
      } else {
        isDark = true;
      }
      this.applyTheme(isDark);
    } catch (error) {
      this.applyTheme(false);
    }
  }

  applyTheme(isDark: boolean): void {
    const html = document.documentElement;
    
    // Fix: keep both in sync
    if (isDark) {
      html.classList.add('dark', 'ion-palette-dark');
      html.setAttribute('data-theme', 'dark');
    } else {
      html.classList.remove('dark', 'ion-palette-dark');
      html.setAttribute('data-theme', 'light');
    }
    this.darkMode.next(isDark);
    localStorage.setItem('elvktheme', isDark ? 'dark' : 'light');
  }
  // === Cookie helpers ===
  setCookie(name: string, value: string, days: number) {
    if (!this.isBrowser) return;
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  getCookie(name: string): string | null {
    if (!this.isBrowser) return null;
    const matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : null;
  }
  
  ngOnDestroy() {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }
}
